module.exports = __webpack_public_path__ + "static/gallery-15-54af39ca9e811a1f3d617e12686b9445.jpg";